import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: var(--space-3xl);
  text-align: center;
`;

const SocialMedia = () => {
  return (
    <Container>
      <h1>Social Media</h1>
      <p>Follow our adventures on Facebook, Instagram, and YouTube!</p>
    </Container>
  );
};

export default SocialMedia;
